import { app } from "@tauri-apps/api";
import tauri from "lib/tauri";

export type FrontendBuildInfo = {
  binaryVersion: string;
  frontendVersion: string;
  frontendSha: string;
  frontendSequence: number;
  builtAt: string;
  channel: "beta" | "release";
};

const BUILD_INFO_PATH = "/frontend-build-info.json";

let cached: FrontendBuildInfo | null | undefined;

const defaultInfo = async (): Promise<FrontendBuildInfo> => {
  const binaryVersion = tauri.enabled ? await app.getVersion() : import.meta.env.VITE_APP_VERSION || "0.0.0";
  return {
    binaryVersion,
    frontendVersion: binaryVersion,
    frontendSha: import.meta.env.VITE_GIT_SHA || "dev",
    frontendSequence: 0,
    builtAt: new Date(0).toISOString(),
    channel: import.meta.env.VITE_BRANCH === "beta" ? "beta" : "release",
  };
};

export async function loadFrontendBuildInfo(): Promise<FrontendBuildInfo> {
  if (cached !== undefined) {
    return cached ?? defaultInfo();
  }

  try {
    const res = await fetch(BUILD_INFO_PATH, { cache: "no-store" });
    if (res.ok) {
      const data = (await res.json()) as FrontendBuildInfo;
      cached = data;
      return data;
    }
  } catch {
    // Embedded or dev build without the file
  }

  cached = null;
  return defaultInfo();
}

export function clearFrontendBuildInfoCache() {
  cached = undefined;
}
